// File: reactnodehelloworld/frontend/src/Sidebar.js
import React from 'react';
import './Sidebar.css';
import { Link } from 'react-router-dom';

function Sidebar() {
  return (
    <div className="sidebar">
      <h2>Sidebar</h2>
      <ul>
      <li><Link to="/app">Home</Link></li>
        <li><Link to="/services">Services</Link></li>
        <li><Link to="/portfolio">portfolio</Link></li>
        <li><Link to="/contact">Contact</Link></li>
        <li><Link to="/chat">PAChat</Link></li>

      </ul>
    </div>
  );
}

export default Sidebar;
